import { render, staticRenderFns } from "./TestReview.vue?vue&type=template&id=e225a55e&scoped=true&"
import script from "./TestReview.vue?vue&type=script&lang=js&"
export * from "./TestReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e225a55e",
  null
  
)

export default component.exports